import React from "react";
import Grid from "@mui/material/Grid";
import useStyles from "./landingStyle-jss";
import Title from "./Title";
import sson from "../../images/services/sso-new.webp";
import vlabs from "../../images/services/vlabs.webp";
import cdac from "../../images/services/service.webp";
import raasLogo from "/app/images/logo/arms.webp";
import rise from "/app/images/ivp.webp";
import forms from "/app/images/forms.webp";
import moodle from "/app/images/logo/moodle.webp";
import quiz from "/app/images/logo/quiz-icon.webp";
import "./Landing.css";

const Services = (props) => {
  const { slideMode } = props;
  const { classes, cx } = useStyles();
  return (
    <div className="my-5">
      {/* <div className={cx(classes.container)}>
        <Grid
          container
          spacing={4}
          className={` gridContainer ${classes.root}`}
        >
          <Grid md={3}>
            <div>cnjnsca</div>
            <div>cnjnsca</div>
            <div>cnjnsca</div>
          </Grid>
        </Grid>

      </div> */}
      <div className={slideMode ? classes.fullWidth : classes.container}>
        <Title
          title="Services"
          desc="Integrated all your services at one platform"
          align="center"
          monocolor={slideMode && true}
        />
        {/* <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="Heading text-center">
                <h2>Service </h2>
              </div>
            </div>
          </div>
        </div> */}
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="section_our_solution">
                <div className="our_solution_category">
                  <div className="solution_cards_box">
                    <div className="solution_card">
                      <div className="hover_color_bubble"></div>
                      <div className="so_top_icon">
                        <img src={forms} />
                      </div>
                      <div className="solu_title">
                        <h3> RaaS</h3>
                      </div>
                      <div className="solu_description">
                        <p>
                          Optimise Registration Processes with Registration as a
                          Service (RaaS) platform. It simplifies the creation of
                          customised forms for a wide range of purposes,
                          including events and applications. Experience the
                          flexibility of customization and the ease of efficient
                          management.
                        </p>
                        {/* <button
                          type="button"
                          className="read_more_btn float-right mt-3"
                        >
                          Read More
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="section_our_solution">
                <div className="our_solution_category">
                  <div className="solution_cards_box">
                    <div className="solution_card">
                      <div className="hover_color_bubble"></div>
                      <div className="so_top_icon">
                        <img src={rise} />
                      </div>
                      <div className="solu_title">
                        <h3> Virtual Labs</h3>
                      </div>
                      <div className="solu_description">
                        <p>
                          {/* Physical distances and the lack of resources make us
                          unable to perform experiments, especially when they
                          involve sophisticated instruments. */}
                          Virtual labs enable students to perform many
                          experiments that are difficult to perform in real
                          laboratories because of the risks. A larger variety of
                          lab experiments can be offered remotely.
                        </p>
                        {/* <button
                          type="button"
                          className="read_more_btn float-right mt-3"
                        >
                          Read More
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="section_our_solution">
                <div className="our_solution_category">
                  <div className="solution_cards_box">
                    <div className="solution_card">
                      <div className="hover_color_bubble"></div>
                      <div className="so_top_icon">
                        <img src={moodle} />
                      </div>
                      <div className="solu_title">
                        <h3>Learning Management System</h3>
                      </div>
                      <div className="solu_description">
                        <p>
                          {/* It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout. */}
                          LMS perform the core training functions like creation,
                          management, and delivery of courses and other
                          eLearning material. It also monitor learner's learning
                          progress, improve their professionalism, and provide a
                          validated certificate.
                        </p>
                        {/* <button
                          type="button"
                          className="read_more_btn float-right mt-3"
                        >
                          Read More
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="section_our_solution">
                <div className="our_solution_category">
                  <div className="solution_cards_box">
                    <div className="solution_card">
                      <div className="hover_color_bubble"></div>
                      <div className="so_top_icon">
                        <img src={quiz} />
                      </div>
                      <div className="solu_title">
                        <h3>Quiz</h3>
                      </div>
                      <div className="solu_description">
                        <p>
                          {/* It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout. */}
                          Interactive Learning and Gaming through a Quiz
                          Platform empowers users to both create their own
                          quizzes and Capture The Flag (CTF) challenges, as well
                          as participate in a wide range of quizzes and CTF
                          events, fostering knowledge-sharing and competitive
                          engagement.
                        </p>
                        {/* <button
                          type="button"
                          className="read_more_btn float-right mt-3"
                        >
                          Read More
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
